export const ROLE_LABELS = {
  student: 'Студент', foreign_student: 'Иностранный студент', postgrad: 'Аспирант', dpo_student: 'Слушатель ДПО',
  teacher: 'Преподаватель', curator: 'Куратор', head_of_department: 'Заведующий кафедрой', dean: 'Декан',
  methodist: 'Учебный отдел', hr_students: 'Отдел кадров · студенты', hr_employees: 'Отдел кадров · сотрудники',
  accountant: 'Бухгалтерия', archivist: 'Архив', rectorate: 'Ректорат', sysadmin: 'Администратор системы',
  parent: 'Представитель студента', applicant: 'Абитуриент', dorm_staff: 'Сотрудник общежития', proctor: 'Проктор',
}

export const STUDENT_ROLES = ['student', 'foreign_student', 'postgrad', 'dpo_student']
export const ACADEMIC_ROLES = ['methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin']
export const HR_STUDENT_ROLES = ['hr_students', 'hr_employees']
export const SYSTEM_ROLES = ['sysadmin', 'rectorate']

export function roleCodes(roles = []) {
  return (Array.isArray(roles) ? roles : []).map((role) => typeof role === 'string' ? role : role?.code).filter(Boolean)
}

export function hasRoles(roles, required = [], isSuper = false) {
  if (isSuper) return true
  const codes = new Set(roleCodes(roles))
  // Special student categories inherit the basic learning services.
  if (STUDENT_ROLES.some((code) => codes.has(code))) codes.add('student')
  return !required.length || required.some((code) => codes.has(code))
}

export const CAPABILITY_ROLES = {
  'students.manage': HR_STUDENT_ROLES,
  'certificates.issue': HR_STUDENT_ROLES,
  'employees.manage': ['hr_employees', ...SYSTEM_ROLES],
  'academic.manage': ACADEMIC_ROLES,
  'structure.manage': [...ACADEMIC_ROLES, ...HR_STUDENT_ROLES],
  'accounting.manage': ['accountant', ...SYSTEM_ROLES],
  'archive.manage': ['archivist', 'hr_students', 'hr_employees', 'methodist', 'dean', ...SYSTEM_ROLES],
  'system.manage': SYSTEM_ROLES,
}

export function hasCapability(auth, capability) {
  if (auth?.me?.is_superuser) return true
  const declared = auth?.me?.capabilities
  if (Array.isArray(declared)) return declared.includes(capability)
  return hasRoles(auth?.roles, CAPABILITY_ROLES[capability] || ['__unassigned__'])
}

// Sensitive personnel registries have narrower access than academic rosters.
export function requiredRolesForPath(pathname) {
  if (/^\/archive\/students(\/|$)/.test(pathname)) return HR_STUDENT_ROLES
  if (/^\/archive\/employees(\/|$)/.test(pathname)) return ['hr_employees', ...SYSTEM_ROLES]
  if (/^\/(students-list|admission|admission-applications|transfers|student-lifecycle|foreign-students|military-students)(\/|$)/.test(pathname)) return HR_STUDENT_ROLES
  if (/^\/institution-structure(\/|$)/.test(pathname)) return [...ACADEMIC_ROLES, ...HR_STUDENT_ROLES]
  if (/^\/(groups|syllabuses|syllabus-builder|schedule-builder|schedule-import|sessions)(\/|$)/.test(pathname)) return ACADEMIC_ROLES
  if (/^\/(admin\/integrations|admin\/services|help\/api)(\/|$)/.test(pathname)) return SYSTEM_ROLES
  return null
}

export const NAV_SECTIONS = {
  workspace: 'Рабочее пространство', academic: 'Учебный процесс', people: 'Контингент и кадры',
  finance: 'Финансы и документы', services: 'Сервисы', system: 'Управление',
}

export function navSection(path) {
  if (/^\/(admin|help\/api)/.test(path)) return 'system'
  if (/^\/(students-list|employees|admission|admission-applications|transfers|orders|employee-wizard|foreign-students|military-students|institution-structure|groups)/.test(path)) return 'people'
  if (/^\/(accounting|archive|reports)/.test(path)) return 'finance'
  if (/^\/(schedule|syllabus|my-syllabus|journal|gradebook|assignments|tests|test-builder|question-bank|sessions|my-disciplines|workload|teacher-statements|dean-dashboard|curator)/.test(path)) return 'academic'
  if (/^\/(home|student-home|teacher-home|applicant-home|tasks|notes|calendar|chats|statements|personalcard|help)/.test(path)) return 'workspace'
  return 'services'
}
